// import React from 'react'
// import Header from './Header'

// // sample excel file 
// import sample_excel from '../assets/sample excel/Lexile_data_export_sample.xlsx'

// //icons
// import { FiEdit } from "react-icons/fi";
// import DataTable from './DataTable';
// import axios from 'axios';
// import { upload } from '@testing-library/user-event/dist/upload';
// import { API } from './constant';

// const Student = () => {


//     return (
//         <div>
//             <div>
//                 <Header />
//                 <div className='flex justify-center mt-[150px]'>
//                     <div className='max-w-[1500px] w-full  ' >
//                         {/* Class, section,and search bar start  */}

//                         {/* <div className='my-[20px] flex justify-between'>
//                             <div className='w-[45%]'>
//                                 <div className=''>
//                                     <label className='text-[18px] ' htmlFor="">Select Class Name:</label>
//                                 </div>
//                                 <div  >
//                                     <select className='w-full bg-black/80 text-white py-[10px] px-[10px] outline-none rounded-md'>
//                                         <option value="">Select Class Name</option>
//                                         <option value="">I</option>
//                                         <option value="">II</option>
//                                         <option value="">III</option>
//                                     </select>
//                                 </div>
//                             </div>

//                             <div className='w-[45%]'>
//                                 <div className=''>
//                                     <label className='text-[18px] ' htmlFor="">Select Section Name:</label>
//                                 </div>
//                                 <div  >
//                                     <select className='w-full bg-black/80 text-white py-[10px] px-[10px] outline-none rounded-md'>
//                                         <option value="">Select Section  Name</option>
//                                         <option value="">I</option>
//                                         <option value="">II</option>
//                                         <option value="">III</option>
//                                     </select>
//                                 </div>
//                             </div>

//                             <div className='my-[20px] w-[30%] flex justify-between'>
//                                 <input className='w-full bg-black/80 text-white py-[10px] px-[10px] outline-none rounded-md' type="search" placeholder='Search Name' />
//                             </div>
//                         </div> */}

//                         {/* Class, section,and search bar end  */}

//                         <div>
//                             {/* <table className='w-full border-collapse'>
//                                 <thead>
//                                     <tr className='w-full  border-collapse bg-[#8321A8] text-white'>
//                                         <th className='border-[1px] border-black border-collapse'>ERP id</th>
//                                         <th className='border-[1px] border-black border-collapse'>Student Name</th>
//                                         <th className='border-[1px] border-black border-collapse'>Class</th>
//                                         <th className='border-[1px] border-black border-collapse'>Section</th>
//                                         <th className='border-[1px] border-black border-collapse'>Lexile Score</th>
//                                         <th className='border-[1px] border-black border-collapse'>AVG.Lexile Score</th>
//                                         <th className='border-[1px] border-black border-collapse'>Update</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody className='w-full'>
//                                     <tr className='border-[1px] border-black  border-collapse hover:bg-[#EEA3F7]'>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>1.</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>Neeeraj</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>4</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>a</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>1000</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>1200</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'><FiEdit size={20} /></td>
//                                     </tr>
//                                     <tr className='border-[1px] border-black  border-collapse hover:bg-[#EEA3F7]'>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>2.</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>Neeeraj</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>4</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>a</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>1000</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>1200</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'><FiEdit size={20} /></td>

//                                     </tr>
//                                     <tr className='border-[1px] border-black  border-collapse hover:bg-[#EEA3F7]'>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>3.</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>Neeeraj</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>4</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>a</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>1000</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>1200</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'><FiEdit size={20} /></td>

//                                     </tr>
//                                     <tr className='border-[1px] border-black  border-collapse hover:bg-[#EEA3F7]'>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>4.</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>Neeeraj</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>4</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>a</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>1000</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle'>1200</td>
//                                         <td className='border-[1px] border-black border-collapse text-center align-middle '><FiEdit  size={20} /></td>

//                                     </tr>
//                                 </tbody>
//                             </table> */}

//                             <div className='flex justify-around items-center'>
//                                 <p>You can download the sample excel file to upload student data from here. <a className='text-blue-700' href={sample_excel}>Download Sample</a> </p>
//                                <div>
//                                 <form action={`${API}/upload`} encType='multipart/form-data' method='post'>
//                                 <input type="file" name='file' id='actual-btn' accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'  hidden />
//                                 <label htmlFor="actual-btn" className='bg-[#1c1d20] text-white px-[20px] py-[5px] rounded-md cursor-pointer'>Import</label>
//                                 <input type="submit" value="Upload" className='mx-[10px] px-[10px] py-[3px] rounded-md bg-green-600 text-white hover:bg-green-800' />
//                                 </form>
//                                </div>


//                             </div>
//                             <DataTable />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Student


import React, { useEffect, useState } from 'react'
import Header from './Header'

// sample excel file 
import sample_excel from '../assets/sample excel/Lexile_data_export_sample.xlsx'

//icons
import { FiEdit } from "react-icons/fi";
import DataTable from './DataTable';
import axios from 'axios';
import { upload } from '@testing-library/user-event/dist/upload';
import { API } from './constant';

const Student = () => {

    const [uploadError, setUploadError] = useState(null);
    const [uploadSuccess, setUploadSuccess] = useState(null);

    // Function to handle file upload with headers
    const handleFileUpload = async (event) => {
        event.preventDefault(); // Prevent default form submission

        const fileInput = event.target.querySelector('input[type="file"]');
        const file = fileInput.files[0];

        if (!file) {
            setUploadError('Please select a file to upload.');
            return;
        }

        // Create FormData object to send the file
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await axios.post(`${API}/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data', // Required for file uploads
                    token: localStorage.getItem('token'), // Same header as in handleReportCard
                },
            });

            // Handle successful upload
            setUploadSuccess('File uploaded successfully!');
            setUploadError(null);
            console.log('Upload response:', response.data);

            // Optionally reset the form
            event.target.reset();
        } catch (error) {
            console.error('Upload error:', error);
            setUploadError('Failed to upload file. Please try again.');
            setUploadSuccess(null);
        }
    };


    //============= ============find user role and give permission start ============================
    const [loggedinRole, setLoggedinRole] = useState("")
    useEffect(() => {
        axios.get(`${API}/login/logged-in-user`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                setLoggedinRole(res.data.data.role)
            })
            .catch((err) => {
                // console.log(err);
                if (err.response) {
                    // Handle invalid token
                    if (err.response.status === 401) {
                        localStorage.removeItem("token");
                        // history.push('/');
                        window.location.href = "/"
                    }
                    // Handle token expiration
                    else if (err.response.status === 302) {
                        window.location.href = "/"

                    }
                }
            });
    }, [])

    //============= ============find user role and give permission end ============================



    return (
        <div>
            {
                loggedinRole === "admin" || "Super Admin" ? (

                    <div className=''>
                        <Header />
                        <div className='flex justify-center mt-[60px] sm:mt-[150px]'>
                            <div className='max-w-[1500px] w-full  ' >
                                {/* Class, section,and search bar start  */}

                                {/* <div className='my-[20px] flex justify-between'>
                            <div className='w-[45%]'>
                                <div className=''>
                                    <label className='text-[18px] ' htmlFor="">Select Class Name:</label>
                                </div>
                                <div  >
                                    <select className='w-full bg-black/80 text-white py-[10px] px-[10px] outline-none rounded-md'>
                                        <option value="">Select Class Name</option>
                                        <option value="">I</option>
                                        <option value="">II</option>
                                        <option value="">III</option>
                                    </select>
                                </div>
                            </div>

                            <div className='w-[45%]'>
                                <div className=''>
                                    <label className='text-[18px] ' htmlFor="">Select Section Name:</label>
                                </div>
                                <div  >
                                    <select className='w-full bg-black/80 text-white py-[10px] px-[10px] outline-none rounded-md'>
                                        <option value="">Select Section  Name</option>
                                        <option value="">I</option>
                                        <option value="">II</option>
                                        <option value="">III</option>
                                    </select>
                                </div>
                            </div>

                            <div className='my-[20px] w-[30%] flex justify-between'>
                                <input className='w-full bg-black/80 text-white py-[10px] px-[10px] outline-none rounded-md' type="search" placeholder='Search Name' />
                            </div>
                        </div> */}

                                {/* Class, section,and search bar end  */}

                                <div>
                                    {/* <table className='w-full border-collapse'>
                                <thead>
                                    <tr className='w-full  border-collapse bg-[#8321A8] text-white'>
                                        <th className='border-[1px] border-black border-collapse'>ERP id</th>
                                        <th className='border-[1px] border-black border-collapse'>Student Name</th>
                                        <th className='border-[1px] border-black border-collapse'>Class</th>
                                        <th className='border-[1px] border-black border-collapse'>Section</th>
                                        <th className='border-[1px] border-black border-collapse'>Lexile Score</th>
                                        <th className='border-[1px] border-black border-collapse'>AVG.Lexile Score</th>
                                        <th className='border-[1px] border-black border-collapse'>Update</th>
                                    </tr>
                                </thead>
                                <tbody className='w-full'>
                                    <tr className='border-[1px] border-black  border-collapse hover:bg-[#EEA3F7]'>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>1.</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>Neeeraj</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>4</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>a</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>1000</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>1200</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'><FiEdit size={20} /></td>
                                    </tr>
                                    <tr className='border-[1px] border-black  border-collapse hover:bg-[#EEA3F7]'>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>2.</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>Neeeraj</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>4</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>a</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>1000</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>1200</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'><FiEdit size={20} /></td>

                                    </tr>
                                    <tr className='border-[1px] border-black  border-collapse hover:bg-[#EEA3F7]'>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>3.</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>Neeeraj</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>4</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>a</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>1000</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>1200</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'><FiEdit size={20} /></td>

                                    </tr>
                                    <tr className='border-[1px] border-black  border-collapse hover:bg-[#EEA3F7]'>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>4.</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>Neeeraj</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>4</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>a</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>1000</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle'>1200</td>
                                        <td className='border-[1px] border-black border-collapse text-center align-middle '><FiEdit  size={20} /></td>

                                    </tr>
                                </tbody>
                            </table> */}
                                    {
                                        loggedinRole === "admin" || loggedinRole === "Super Admin" ? (

                                            <div className='block sm:flex px-[3px] justify-around items-center mt-3 text-[10px] sm:text-[12px] '>
                                                <p>You can download the sample excel file to upload student data from here. <a className='text-blue-700' href={sample_excel}>Download Sample</a> </p>
                                                <div>
                                                    {/* <form action={`${API}/upload`} encType='multipart/form-data' method='post'>
                                <input type="file" name='file' id='actual-btn' accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'  hidden />
                                <label htmlFor="actual-btn" className='bg-[#1c1d20] text-white px-[20px] py-[5px] rounded-md cursor-pointer'>Import</label>
                                <input type="submit" value="Upload" className='mx-[10px] px-[10px] py-[3px] rounded-md bg-green-600 text-white hover:bg-green-800' />
                                </form> */}

                                                    <form onSubmit={handleFileUpload} encType="multipart/form-data">
                                                        <input
                                                            type="file"
                                                            name="file"
                                                            id="actual-btn"
                                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                            hidden
                                                        />
                                                        <label
                                                            htmlFor="actual-btn"
                                                            className="bg-[#1c1d20] text-white px-[20px] py-[5px] rounded-md cursor-pointer"
                                                        >
                                                            Import
                                                        </label>
                                                        <input
                                                            type="submit"
                                                            value="Upload"
                                                            className="mx-[10px] px-[10px] py-[3px] rounded-md bg-green-600 text-white hover:bg-green-800"
                                                        />
                                                    </form>
                                                </div>
                                                {/* Display upload status */}
                                                {uploadSuccess && <p className="text-green-600">{uploadSuccess}</p>}
                                                {uploadError && <p className="text-red-600">{uploadError}</p>}
                                            </div>
                                        ) : null
                                    }



                                    <DataTable />
                                </div>
                            </div>
                        </div>
                    </div>

                ) : (
                    <>
                        <p>You are not Authorized</p>
                    </>
                )
            }
        </div>
    )
}

export default Student